import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, MessageCircle } from 'lucide-react';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  return <AnimatePresence data-id="element-95">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.8
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 50,
      scale: 0.8
    }} className="fixed bottom-6 right-6 z-[9999] flex flex-col gap-3" data-id="element-96">
          <a href="sms:8325034445?body=Hi, I'd like a free quote for lawn service" className="flex items-center justify-center w-14 h-14 bg-[#C5A55A] text-[#1B2E1B] rounded-full shadow-[0_4px_20px_rgba(197,165,90,0.5)] hover:bg-[#d4b46a] transition-colors cursor-pointer" aria-label="Text us for a quote" data-id="element-97">
            <MessageCircle className="w-6 h-6" data-id="element-98" />
          </a>
          <a href="tel:8325034445" className="flex items-center justify-center w-14 h-14 bg-[#2D5A27] text-white rounded-full shadow-[0_4px_20px_rgba(45,90,39,0.5)] hover:bg-[#1B2E1B] transition-colors cursor-pointer" aria-label="Call now" data-id="element-99">
            <Phone className="w-6 h-6" data-id="element-100" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}